import { SUPABASE_URL, SUPABASE_ANON_KEY } from './supabaseClient'

export async function lookupZefix(input, { signal } = {}) {
  const response = await fetch(`${SUPABASE_URL}/functions/v1/search-zefix`, {
    method: 'POST', signal,
    headers: { 'Content-Type': 'application/json', apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}` },
    body: JSON.stringify(input),
  })
  if (!response.ok) throw new Error('search_unavailable')
  return response.json()
}
